import * as React from "react";

function SvgAvatar(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
      <g data-name="Grupo de m\xE1scara 32">
        <path
          d="M13.643 10.713a6 6 0 10-7.4 0 10.025 10.025 0 00-6.237 8.165 1.009 1.009 0 001 1.122.985.985 0 00.985-.866 8 8 0 0115.906 0 .985.985 0 00.985.866 1.009 1.009 0 001-1.122 10.025 10.025 0 00-6.239-8.165zM5.943 6a4 4 0 114 4 4 4 0 01-4-4z"
          data-name="Caminho 101"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgAvatar;

